import React, { useContext, useRef } from "react";
import { StateContext } from "../state/index";
import BaseContent from './BaseContent';
import { useCustomCSS } from "../utils/hooks";

export const PaymentAccepted = () => {
  const [{configuration}] = useContext(StateContext);
  const componentRef = useRef();
  useCustomCSS(componentRef, 'networkSelectionAccepted');

  return (
    <BaseContent {...configuration.networkSelectionAccepted} ref={componentRef} />
  );
};

export default PaymentAccepted;
